import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stripe-s': {
    width: 362,
    height: 512,
    paths: [
      {
        d: 'M144.3 154.6C144.3 132.3 162.9 123.7 192.7 123.7 236.1 123.7 291.2 137 334.6 160.4V26.1C287.3 7.2 240.1 0 192.8 0 77.1 0 0 60.4 0 161.4 0 319.3 216.8 293.7 216.8 361.8 216.8 388.2 193.9 396.7 162.1 396.7 114.9 396.7 53.9 377.2 6 351.2V479.7C59 502.5 112.8 512.1 162 512.1 280.6 512.1 362.3 461.1 362.3 358.5 362.3 188.3 144.3 218.8 144.3 154.6'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stripe-s.js
// module id = gWIX
// module chunks = 144